import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CustomerSerivce {
  apiBaseUrl = environment.apiBaseUrl;

  constructor(private _httpClient: HttpClient) {}

  get(params: { 'page[number]': number, 'page[size]': number, 'orderBy[modifiedOn]': string, 'searchFilter[name]'?: string,}) {
    return this._httpClient.get(`${this.apiBaseUrl}/customers`, { params });
  }

  getCustomers() {
    return this._httpClient.get(`${this.apiBaseUrl}/customers`);
  }

  getSearchCustomers(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/customers${query}`);
  }

  getCustomerById(id: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/customers/${id}`);
  }

  getBookings(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/bookings${query}`);
  }

  getLocationById(id: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/locations/${id}`);
  }

}
